import { OneToOneRawAudioMessage, RawAudioMessage } from "@/store/chats/types";
import { isOneToOneChat } from "@/firebase/utils";

export const getIsOneToOneRawAudioMessage = (
  _: RawAudioMessage,
  chatId: string,
): _ is OneToOneRawAudioMessage => {
  return isOneToOneChat(chatId);
};
